import type React from 'react';
import { useId } from 'react';
import { classNames } from '@/lib/utils';
import type { TextInputProps } from './TextInput.types';

export const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  label,
  error,
  className = '',
  fullWidth = false,
  icon,
  iconAlt,
  id,
  type = 'text',
  ...props
}) => {
  const fallbackId = useId();
  const inputId = id ?? fallbackId;
  const hasError = Boolean(error);

  return (
    <div className={classNames('flex flex-col gap-2', fullWidth ? 'w-full' : '', className)}>
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-white">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <img
            src={icon}
            alt={iconAlt || 'Input icon'}
            className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 opacity-50"
          />
        )}
        <input
          id={inputId}
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={classNames(
            'w-full bg-panel-input-background border rounded px-4 py-2 text-white',
            'focus:outline-none focus:border-panel-input-focus',
            'transition-colors duration-200',
            'placeholder:text-gray-500',
            hasError ? 'border-red-500' : 'border-panel-input-border',
            icon ? 'pl-10' : '',
            props.disabled ? 'opacity-50 cursor-not-allowed' : '',
          )}
          {...props}
        />
      </div>
      {error && typeof error === 'string' && <div className="text-red-500 text-sm">{error}</div>}
    </div>
  );
};
